


















































































































import Vue, { PropType } from 'vue'
import XInput from '@/components/atoms/Input/XInput.vue'
import XButton from '@/components/atoms/Button/XButton.vue'
import XCard from '@/components/atoms/Card/XCard.vue'
import XForm from '@/components/atoms/Form/XForm.vue'
import XFormLabel from '@/components/atoms/FormLabel/XFormLabel.vue'
import AccountTypePicker from '@/components/molecules/PartnerBankAccounts/AccountTypePicker.vue'
import StorePicker from '@/components/molecules/StorePicker/StorePicker.vue'
import { CreatePartnerBankAccountInput } from '@/types/generated/graphql'

type Data = {
  partnerId: string
}

type Methods = {
  onClickSave: () => void
}

type Props = {
  bankAccount: CreatePartnerBankAccountInput
}

export default Vue.extend<Data, Methods, {}, Props>({
  name: 'BankAccountForm',
  components: {
    XInput,
    XButton,
    XCard,
    XForm,
    XFormLabel,
    AccountTypePicker,
    StorePicker,
  },
  props: {
    bankAccount: {
      type: Object as PropType<CreatePartnerBankAccountInput>,
      required: true,
    },
  },
  data() {
    return {
      partnerId: this.$route.params.partnerId,
    }
  },
  methods: {
    async onClickSave() {
      this.$emit('click:save', this.bankAccount)
    },
  },
})
